// Custom Collection Filters JavaScript
document.addEventListener('DOMContentLoaded', function() {
  const customFilters = document.querySelector('.custom-collection-filters');
  if (!customFilters) return;

  // Get all filter elements
  const filterLinks = document.querySelectorAll('.custom-collection-filters__subcategory');
  const filterWrapper = document.querySelector('[data-filter-wrapper]');
  
  if (!filterWrapper || !filterLinks.length) return;

  // Check active filters on page load
  updateActiveFilters();
  
  // Add click event listeners to all filter links
  filterLinks.forEach(link => {
    link.addEventListener('click', handleFilterClick);
  });

  // Handle filter click events
  function handleFilterClick(event) {
    event.preventDefault();
    
    const link = event.currentTarget;
    const filterType = link.getAttribute('data-filter-type');
    const filterValue = link.getAttribute('data-filter-value');
    
    // Show loading state
    document.body.classList.add('is-loading');
    
    // Store filter bar state in localStorage to prevent it from opening after page reload
    localStorage.setItem('keepFilterBarClosed', 'true');
    
    if (filterType === 'view-all') {
      // Remove all product type and vendor filters and redirect
      const newUrl = removeAllCustomFilters(window.location.href);
      window.location.href = newUrl;
      return;
    }
    
    // Toggle the filter
    const isActive = link.classList.contains('custom-collection-filters__subcategory--active');
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    
    if (filterType === 'product_type') {
      const paramName = `filter.p.product_type`;
      
      if (isActive) {
        // Remove this filter
        const currentFilters = getAllProductTypeFilters();
        
        // Remove the one we clicked on
        const updatedFilters = currentFilters.filter(filter => filter !== filterValue);
        
        // Clear all existing product type filters
        const urlParams = new URLSearchParams(window.location.search);
        const paramKeysToRemove = [];
        
        urlParams.forEach((value, key) => {
          if (key.startsWith('filter.p.product_type')) {
            paramKeysToRemove.push(key);
          }
        });
        
        paramKeysToRemove.forEach(key => {
          searchParams.delete(key);
        });
        
        // Add back the remaining filters
        updatedFilters.forEach(filter => {
          searchParams.append(`filter.p.product_type`, filter);
        });
      } else {
        // Add this filter
        searchParams.append(paramName, filterValue);
      }
      
      window.location.href = url.toString();
    } else if (filterType === 'vendor') {
      const paramName = `filter.p.vendor`;
      
      if (isActive) {
        // Remove this filter
        const currentFilters = getAllVendorFilters();
        
        // Remove the one we clicked on
        const updatedFilters = currentFilters.filter(filter => filter !== filterValue);
        
        // Clear all existing vendor filters
        const urlParams = new URLSearchParams(window.location.search);
        const paramKeysToRemove = [];
        
        urlParams.forEach((value, key) => {
          if (key.startsWith('filter.p.vendor')) {
            paramKeysToRemove.push(key);
          }
        });
        
        paramKeysToRemove.forEach(key => {
          searchParams.delete(key);
        });
        
        // Add back the remaining filters
        updatedFilters.forEach(filter => {
          searchParams.append(`filter.p.vendor`, filter);
        });
      } else {
        // Add this filter
        searchParams.append(paramName, filterValue);
      }
      
      window.location.href = url.toString();
    }
  }

  // Helper function to get all current product type filters
  function getAllProductTypeFilters() {
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    const filters = [];
    
    searchParams.forEach((value, key) => {
      if (key.startsWith('filter.p.product_type')) {
        filters.push(value);
      }
    });
    
    return filters;
  }

  // Helper function to get all current vendor filters
  function getAllVendorFilters() {
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    const filters = [];
    
    searchParams.forEach((value, key) => {
      if (key.startsWith('filter.p.vendor')) {
        filters.push(value);
      }
    });
    
    return filters;
  }

  // Helper function to remove all product type filters
  function removeAllProductTypeFilters(url) {
    const parsedUrl = new URL(url);
    const searchParams = parsedUrl.searchParams;
    const paramKeysToRemove = [];
    
    searchParams.forEach((value, key) => {
      if (key.startsWith('filter.p.product_type')) {
        paramKeysToRemove.push(key);
      }
    });
    
    paramKeysToRemove.forEach(key => {
      searchParams.delete(key);
    });
    
    return parsedUrl.toString();
  }

  // Helper function to remove all custom filters (product type and vendor)
  function removeAllCustomFilters(url) {
    const parsedUrl = new URL(url);
    const searchParams = parsedUrl.searchParams;
    const paramKeysToRemove = [];
    
    searchParams.forEach((value, key) => {
      if (key.startsWith('filter.p.product_type') || key.startsWith('filter.p.vendor')) {
        paramKeysToRemove.push(key);
      }
    });
    
    paramKeysToRemove.forEach(key => {
      searchParams.delete(key);
    });
    
    return parsedUrl.toString();
  }

  // Update active filters based on URL
  function updateActiveFilters() {
    const productTypeFilters = getAllProductTypeFilters();
    const vendorFilters = getAllVendorFilters();
    const hasActiveFilters = productTypeFilters.length > 0 || vendorFilters.length > 0;
    
    // Handle "View All" button (only if it exists)
    const viewAllButton = document.querySelector('[data-filter-type="view-all"]');
    if (viewAllButton) {
      if (hasActiveFilters) {
        viewAllButton.classList.remove('custom-collection-filters__subcategory--active');
      } else {
        viewAllButton.classList.add('custom-collection-filters__subcategory--active');
      }
    }
    
    // Mark active product filters
    filterLinks.forEach(link => {
      const filterType = link.getAttribute('data-filter-type');
      const filterValue = link.getAttribute('data-filter-value');
      
      if (filterType === 'product_type') {
        if (productTypeFilters.includes(filterValue)) {
          link.classList.add('custom-collection-filters__subcategory--active');
        } else {
          link.classList.remove('custom-collection-filters__subcategory--active');
        }
      } else if (filterType === 'vendor') {
        if (vendorFilters.includes(filterValue)) {
          link.classList.add('custom-collection-filters__subcategory--active');
        } else {
          link.classList.remove('custom-collection-filters__subcategory--active');
        }
      }
    });
  }
  
  // Handle active state for category tabs
  const categoryTabs = customFilters.querySelectorAll('.custom-collection-filters__tab');
  const currentUrlBase = new URL(window.location.href).origin + new URL(window.location.href).pathname;
  
  categoryTabs.forEach(tab => {
    // Remove query parameters for comparison
    const tabUrlBase = new URL(tab.href).origin + new URL(tab.href).pathname;
    
    if (tabUrlBase === currentUrlBase) {
      tab.classList.add('custom-collection-filters__tab--active');
    }
    
    // Add hover effect
    tab.addEventListener('mouseenter', function() {
      if (!this.classList.contains('custom-collection-filters__tab--active')) {
        this.style.borderBottom = '2px solid #000';
      }
    });
    
    tab.addEventListener('mouseleave', function() {
      if (!this.classList.contains('custom-collection-filters__tab--active')) {
        this.style.borderBottom = 'none';
      }
    });
  });
  
  // Check if we need to keep the filter bar closed
  if (localStorage.getItem('keepFilterBarClosed') === 'true') {
    // Keep filter bar closed after page reload
    const filterBarFilters = document.querySelector('.filter-bar__filters');
    if (filterBarFilters) {
      filterBarFilters.style.display = 'none';
      filterBarFilters.setAttribute('aria-hidden', 'true');
      
      // Find the button and update its aria-expanded attribute
      const filterButton = document.querySelector('.filter-bar__button--filters');
      if (filterButton) {
        filterButton.setAttribute('aria-expanded', 'false');
      }
    }
    
    // Remove the flag after we've used it
    localStorage.removeItem('keepFilterBarClosed');
  }
  
  // Add mobile scroll indicators for horizontally scrollable elements
  const scrollableElements = [
    customFilters.querySelector('.custom-collection-filters__tabs'),
    customFilters.querySelector('.custom-collection-filters__subcategories')
  ];
  
  scrollableElements.forEach(el => {
    if (!el) return;
    
    // Check if scrollable
    if (el.scrollWidth > el.clientWidth) {
      el.classList.add('is-scrollable');
      
      // Add scroll indicators
      const scrollIndicator = document.createElement('div');
      scrollIndicator.className = 'scroll-indicator';
      scrollIndicator.innerHTML = '<span>&rsaquo;</span>';
      el.parentNode.appendChild(scrollIndicator);
      
      // Update indicator visibility on scroll
      el.addEventListener('scroll', function() {
        const maxScroll = el.scrollWidth - el.clientWidth;
        const currentScroll = el.scrollLeft;
        
        if (currentScroll >= maxScroll - 10) {
          scrollIndicator.classList.add('hidden');
        } else {
          scrollIndicator.classList.remove('hidden');
        }
      });
      
      // Initial check
      if (el.scrollWidth <= el.clientWidth) {
        scrollIndicator.classList.add('hidden');
      }
    }
  });
  
  // Clear filters button
  const clearFiltersBtn = customFilters.querySelector('.custom-collection-filters__clear-button');
  if (clearFiltersBtn) {
    clearFiltersBtn.addEventListener('click', function(e) {
      console.log('Clear filters clicked:', this.href);
      
      const productGrid = document.querySelector('.collection__products');
      if (productGrid) {
        productGrid.classList.add('is-loading');
      }
    });
  }
  
  // Add the scroll indicator styles
  const style = document.createElement('style');
  style.textContent = `
    .is-scrollable {
      position: relative;
      scrollbar-width: none;
      -ms-overflow-style: none;
    }
    .is-scrollable::-webkit-scrollbar {
      display: none;
    }
    .scroll-indicator {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 30px;
      height: 30px;
      background-color: rgba(255, 255, 255, 0.8);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
      z-index: 2;
      pointer-events: none;
      transition: opacity 0.3s ease;
    }
    .scroll-indicator span {
      font-size: 20px;
      font-weight: bold;
    }
    .scroll-indicator.hidden {
      opacity: 0;
    }
    .collection__products.is-loading {
      opacity: 0.5;
      pointer-events: none;
      transition: opacity 0.3s ease;
    }
    
    /* Mobile font size adjustments */
    @media screen and (max-width: 767px) {
      .custom-collection-filters__tab,
      .custom-collection-filters__subcategory,
      .custom-collection-filters__description,
      .custom-collection-filters__clear-button {
        font-size: 13px !important;
      }
    }
  `;
  document.head.appendChild(style);
}); 